'use client';

import { useEffect, useState } from 'react';

/**
 * useHash
 * - 브라우저의 현재 URL 해시 값을 상태로 관리하는 커스텀 훅입니다.
 * - 해시 값이 변경될 때마다 자동으로 상태가 업데이트됩니다.
 *
 * 특징:
 * - 브라우저의 `hashchange` 이벤트와 커스텀 이벤트(`custom-hash-change`)를 감지.
 * - `history.pushState`로 인한 해시 변경은 기본적으로 감지되지 않으므로,
 *   `custom-hash-change` 이벤트를 사용하여 이를 보완합니다.
 */
export const useHash = () => {
  const [hash, setHash] = useState<string>(() => (typeof window !== 'undefined' ? window.location.hash : ''));

  useEffect(() => {
    const handleHashChange = () => {
      setHash(window.location.hash);
    };

    // 브라우저의 해시 변경 이벤트를 감지
    window.addEventListener('hashchange', handleHashChange);
    // 커스텀 이벤트를 감지 (history.pushState로 인한 변경 처리)
    window.addEventListener('custom-hash-change', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
      window.removeEventListener('custom-hash-change', handleHashChange);
    };
  }, []);

  return hash;
};
